import { useEffect } from "react";
import { FormHelperText } from "@mui/material";
import DatePicker from "@components/DatePicker/DatePicker";
import CustomFormLabel from "@components/FormItem/FormItem.styles";
import { usePortServicesFlow } from "@features/vessel-call/vessel-call-status/PortServices/flow/context/PortServicesFlowContext";
import {
  getAtcAfterAtsError,
  getAtsMustNotBeInPastError,
  getEtcDateOrderError,
  getMustBeAfterMessage,
} from "@features/vessel-call/vessel-call-status/PortServices/flow/utils";

const asDateOrNull = (v: unknown) => (v == null || v === "" ? null : (v as Date));

interface ATSFieldProps {
  serviceDetails: { ats?: Date | null | string };
}

const ATSField = ({ serviceDetails: { ats: currentAts } }: ATSFieldProps) => {
  const { setAts, ats, atc, etc, ets, errors, setErrors } = usePortServicesFlow();

  useEffect(() => {
    if (currentAts instanceof Date) {
      setAts(currentAts);
    } else if (typeof currentAts === "string" && currentAts !== "") {
      setAts(new Date(currentAts));
    } else {
      setAts(null);
    }
  }, []);

  return (
    <div className="flex flex-col gap-2">
      <CustomFormLabel data-testid={`change-status-ATS-label`}>ATS</CustomFormLabel>
      <DatePicker
        hasError={errors.ats !== undefined}
        value={asDateOrNull(ats)}
        onChange={(d) => {
          setAts(d);

          const nextAtsError = getAtsMustNotBeInPastError(d);
          const nextAtcError = getAtcAfterAtsError(atc, d);
          const nextEtcError = getEtcDateOrderError({ etc, ets, ats: d });

          setErrors((prev) => ({
            ...prev,
            ats: nextAtsError,
            atc:
              nextAtcError ??
              (prev.atc === getMustBeAfterMessage("ATC", "ATS") ? undefined : prev.atc),
            etc:
              nextEtcError ??
              (prev.etc === getMustBeAfterMessage("ETC", "ATS") ? undefined : prev.etc),
          }));
        }}
        testId="change-status-ATS-datepicker"
        timePicker={true}
        combinedInput={true}
        dateConstraint="not-past"
      />
      {errors.ats && (
        <FormHelperText sx={{ color: "error.main", m: 0 }}>
          {typeof errors.ats === "string" ? errors.ats : errors.ats?.toString()}
        </FormHelperText>
      )}
    </div>
  );
};

export default ATSField;
